export const ticketEmailBody = ({
  fullname = "User",
  ticketId,
  subject,
  department,
  priority = "Normal",
  createdAt,
  description = "—", // added default description
}) => `
  <p>Hello <strong>${fullname}</strong>,</p>

  <p>
    A new support ticket has been created successfully on the
    <strong>Greenwells Helpdesk Platform</strong>.
  </p>

  <table
    border="1"
    cellpadding="8"
    cellspacing="0"
    style="border-collapse: collapse; margin: 15px 0; width: 100%;"
  >
    <tr style="background-color: #f2f2f2;">
      <th align="left">Ticket ID</th>
      <td>${ticketId}</td>
    </tr>
    <tr>
      <th align="left">Subject</th>
      <td>${subject}</td>
    </tr>
    <tr>
      <th align="left">Department</th>
      <td>${department}</td>
    </tr>
    <tr>
      <th align="left">Priority</th>
      <td>${priority}</td>
    </tr>
    <tr>
      <th align="left">Created On</th>
      <td>${createdAt}</td>
    </tr>
    <tr>
      <th align="left">Additional information</th>
      <td>${description}</td>
    </tr>
  </table>

  <p>
    The assigned team has been notified and will begin working on your request.
    You can track progress, add comments, or close the ticket through the helpdesk.
  </p>

  <p>
    <strong>Access the Helpdesk:</strong><br/>
    <a href="https://helpdesk.greenwellsenergies.co.ke" target="_blank">
      https://helpdesk.greenwellsenergies.co.ke
    </a>
  </p>

  <p>
    Please do not reply to this email. This is an automated notification.
  </p>

  <p>
    Regards,<br/>
    <strong>Greenwells Support Team</strong>
  </p>
`;
